export default __webpack_public_path__ + "static/media/number-4.92d9524b.svg";